import DomainListsDashboard from "./DomainListsDashboard";

export default DomainListsDashboard;
